module.exports = __webpack_public_path__ + "img/zhihu.6ec7e594.png";